<div class="stepper-icon" [class.completed]="completed">
  <mat-icon
    class="icon"
    [class.active]="active"
    [svgIcon]="getIconName()"
    [attr.aria-label]="getIconAlt()">
  </mat-icon>
</div>
